import jsPDF from "jspdf";
import "../fonts/OpenSans-Regular-normal.js"
import "../fonts/OpenSans-SemiBold-bold.js"
import type { FormulaEntry } from "../types/formula";

export function generatePDF(formulas: FormulaEntry[]) {
  const doc = new jsPDF();

  let y = 15;
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 15;
  const maxWidth = pageWidth - margin * 2;

  const lineHeight = 10

  doc.setFont("OpenSans", "bold");
  doc.setFontSize(20);
  doc.text("Matematičke formule", margin, y);
  y += 15; // naslov razmak

  const grouped = formulas.reduce<Record<string, FormulaEntry[]>>((acc, f) => {
    if (!acc[f.category]) acc[f.category] = [];
    acc[f.category]!.push(f);
    return acc;
  }, {});

  Object.entries(grouped).forEach(([category, items]) => {
    if (y > 260) {
      doc.addPage();
      y = 15; // margine na vrhu stranice
    }

    doc.setFont("OpenSans", "bold");
    doc.setFontSize(16);
    doc.text(category, margin, y);
    y += 12; // podnaslov

    items.forEach(f => {
      doc.setFont("OpenSans", "normal");
      doc.setFontSize(14);

      // const descLines = doc.splitTextToSize(f.description, maxWidth);
      // doc.text(descLines, margin, y);
      // y += descLines.length * 5;

      doc.setFont("OpenSans", "normal"); // formula
      const formulaLines = doc.splitTextToSize(f.latex, maxWidth - 5);
      doc.text(formulaLines, margin + lineHeight, y);
      y += formulaLines.length * lineHeight;

      y += 4;

      if (y > 270) {
        doc.addPage();
        y = 15;
      }
    });

    y += 6;
  });

  doc.save("formule.pdf");
}